import { Table, Button, Form, Select, Checkbox, Input } from "antd";
import React, { useState, useEffect } from "react";

import { coverageTypes, procedures } from "../testData";

import arrowDown from "../../../assets/icons/arrow-down12.png";
import plus from "../../../assets/icons/add-circle2.png";
import trash from "../../../assets/icons/trash2.png";

export default function AudienceInsuranceFilter({
  createdInsuranceFilters,
  setCreatedInsuranceFilters,
  newInsurance,
  setNewInsurance,
  setInsuranceFilter,
  insuranceFilter,
}) {
  const [showForm, setShowForm] = useState(true);
  const [checked, setChecked] = useState(false);
  const [allFieldsFill, setAllFieldsFIll] = useState(false);
  const [isArrowDown, setIsArrowDown] = useState(true);

  const patientHistoryTableColumns = [
    {
      title: "Insurance Category",
      dataIndex: "insurance_category",
      key: "insurance_category",
      width: "40%",
      render: (text, record, index) => {
        if (showForm && index === createdInsuranceFilters.length) {
          return (
            <Form.Item name="insurance_category" rules={[{ required: true, message: "Required" }]} style={{ margin: 0 }}>
              <Select
                options={procedures}
                placeholder="Select Category"
                className="custom-style-selection-insurance-filter"
                style={{ width: "100%", display: "flex", alignItems: "center" }}
                suffixIcon={<img src={arrowDown} alt="arrow-down" style={{ transform: `rotate(${isArrowDown ? "0" : "180deg"})` }} />}
                value={newInsurance.insurance_category}
                onOpenChange={() => setIsArrowDown((down) => !down)}
                onChange={(value) => setNewInsurance((prevData) => ({ ...prevData, insurance_category: value }))}
              />
            </Form.Item>
          );
        }
        return text;
      },
    },
    {
      title: "Coverage Type",
      dataIndex: "coverage_type",
      key: "coverage_type",
      width: "30%",
      render: (text, record, index) => {
        if (showForm && index === createdInsuranceFilters.length) {
          return (
            <Form.Item name="insurance_category" rules={[{ required: true, message: "Required" }]} style={{ margin: 0 }}>
              <Select
                options={coverageTypes}
                placeholder="Select Coverage Type"
                className="custom-style-selection-insurance-filter"
                style={{ width: "100%", display: "flex", alignItems: "center" }}
                suffixIcon={<img src={arrowDown} alt="arrow-down" style={{ transform: `rotate(${isArrowDown ? "0" : "180deg"})` }} />}
                value={newInsurance.coverage_types}
                onOpenChange={() => setIsArrowDown((down) => !down)}
                onChange={(value) => setNewInsurance((prevData) => ({ ...prevData, coverage_types: value }))}
              />
            </Form.Item>
          );
        }
        return text;
      },
    },
    {
      title: "Insurance Coverage",
      dataIndex: "insurance_coverage",
      width: "30%",
      key: "insurance_coverage",
      render: (text, record, index) => {
        if (showForm && index === createdInsuranceFilters.length) {
          return (
            <Form.Item name="insurance_coverage" rules={[{ required: true, message: "Required" }]} style={{ margin: 0 }}>
              {/* <Select
                options={procedures}
                placeholder="Select Coverage"
                value={newInsurance.procedure_code}
                onChange={(value) => setNewInsurance((prevData) => ({ ...prevData, insurance_coverage: value }))}
              /> */}
              <Input
                placeholder="Enter Coverage"
                value={newInsurance.insurance_coverage}
                style={{ border: "1px solid #6b43b5" }}
                onChange={(e) => setNewInsurance((prevData) => ({ ...prevData, insurance_coverage: e.target.value }))}
              />
            </Form.Item>
          );
        }
        return text;
      },
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (text, record, index) => {
        return (
          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            {showForm && index === createdInsuranceFilters.length ? (
              <Checkbox checked={checked} disabled={!allFieldsFill} onChange={() => setChecked((prev) => !prev)} className="custom-action-checkbox" />
            ) : (
              <img
                src={trash}
                alt="trash"
                onClick={() => setCreatedInsuranceFilters((prevFilters) => prevFilters.filter((prevFilter) => prevFilter.key !== record.key))}
              />
            )}
          </div>
        );
      },
    },
  ];

  // Enable checkbox only when all fields are filled
  useEffect(() => {
    const filled = newInsurance.insurance_category && newInsurance.insurance_coverage && newInsurance.coverage_types;
    setAllFieldsFIll(!!filled);
  }, [newInsurance]);

  // When checkbox is checked, add the filter and reset
  useEffect(() => {
    if (checked && allFieldsFill) {
      setCreatedInsuranceFilters((prev) => [...prev, { ...newInsurance }]);
      setInsuranceFilter((prev) => [
        ...prev,
        {
          char_value: newInsurance.insurance_category,
          float_value: newInsurance.insurance_coverage,
          text_value: newInsurance.coverage_types,
        },
      ]);
      setNewInsurance({ insurance_category: "", insurance_coverage: "", coverage_types: "" });
      setChecked(false);
      setShowForm(false);
    }
  }, [checked]);

  // Show the form if all filters get removed
  useEffect(() => {
    if (createdInsuranceFilters.length === 0) {
      setShowForm(true);
    }
  }, [createdInsuranceFilters]);

  // Compose table data
  const tableData = showForm ? [...createdInsuranceFilters, { key: "form-row" }] : createdInsuranceFilters;

  return (
    <div>
      <Table columns={patientHistoryTableColumns} dataSource={tableData} rowKey={(record, index) => index} pagination={false} />

      <Button
        style={{
          width: "100%",
          borderRadius: "0 0 10px 10px",
          padding: "20px 0",
          color: "#6B43B5",
          border: "1px solid #6b43B5",
        }}
        onClick={() => setShowForm(true)}
        disabled={showForm && !allFieldsFill}
      >
        {showForm && allFieldsFill ? (
          "Save"
        ) : (
          <>
            Add Another Insurance <img src={plus} alt="add" />
          </>
        )}
      </Button>
    </div>
  );
}
